exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1dPnOmcN3P4-J0LJRcD2sO{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;width:100%}._15oQAa4nRfUvID1FuJffCH{min-width:11.42857rem}._13DIqebgOCNPq4LhfLxciY{font-weight:600}._1dPnOmcN3P4-J0LJRcD2sO label{font-weight:600;margin-left:1.07143rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Filter": "_1dPnOmcN3P4-J0LJRcD2sO",
	"Filter_select": "_15oQAa4nRfUvID1FuJffCH",
	"Filter_label": "_13DIqebgOCNPq4LhfLxciY"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/UserDashboard/MyTasks/style.postcss
// module id = 2088
// module chunks = 0